/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBaseLanguageControllerLanguage } from '../fn/language/get-many-base-language-controller-language';
import { GetManyBaseLanguageControllerLanguage$Params } from '../fn/language/get-many-base-language-controller-language';
import { GetManyLanguageResponseDto } from '../models/get-many-language-response-dto';
import { getOneBaseLanguageControllerLanguage } from '../fn/language/get-one-base-language-controller-language';
import { GetOneBaseLanguageControllerLanguage$Params } from '../fn/language/get-one-base-language-controller-language';
import { Language } from '../models/language';

@Injectable({ providedIn: 'root' })
export class LanguageApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseLanguageControllerLanguage()` */
  static readonly GetManyBaseLanguageControllerLanguagePath = '/api/languages';

  /**
   * Retrieve multiple Languages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseLanguageControllerLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseLanguageControllerLanguage$Response(params?: GetManyBaseLanguageControllerLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyLanguageResponseDto>> {
    const obs = getManyBaseLanguageControllerLanguage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Languages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseLanguageControllerLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseLanguageControllerLanguage(params?: GetManyBaseLanguageControllerLanguage$Params, context?: HttpContext): Observable<GetManyLanguageResponseDto> {
    const resp = this.getManyBaseLanguageControllerLanguage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyLanguageResponseDto>): GetManyLanguageResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseLanguageControllerLanguage()` */
  static readonly GetOneBaseLanguageControllerLanguagePath = '/api/languages/{id}';

  /**
   * Retrieve a single Language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseLanguageControllerLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseLanguageControllerLanguage$Response(params: GetOneBaseLanguageControllerLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<Language>> {
    const obs = getOneBaseLanguageControllerLanguage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseLanguageControllerLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseLanguageControllerLanguage(params: GetOneBaseLanguageControllerLanguage$Params, context?: HttpContext): Observable<Language> {
    const resp = this.getOneBaseLanguageControllerLanguage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Language>): Language => r.body)
    );
  }

}
